import React, { createContext, useContext } from 'react';
import useResponsive from '../hooks/useResponsive';

const ThemeContext = createContext();

export const ThemeProvider = ({ children }) => {
  const isMobile = useResponsive('(max-width: 767px)');

  const value = {
    isMobile,
  };

  return (
    <ThemeContext.Provider value={value}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (context === undefined) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}; 